export const categoryListSelector = (state) => state.category.categoryList

